<template>
  <div class="col-messages" v-show="(isMobile && !showRoomsList) || !isMobile">
    <div class="room-header app-border-b">
      <div class="room-wrapper">
        <div
          v-if="!singleRoom"
          class="svg-button toggle-button"
          :class="{ 'rotate-icon': !showRoomsList && !isMobile }"
          @click="$emit('toggleRoomsList')"
        >
          <svg-icon name="toggle" />
        </div>
        <div
          class="info-wrapper"
          :class="{ 'item-clickable': roomInfo }"
          @click="$emit('roomInfo', room)"
        >
          <slot name="room-info" v-bind="{'room': room}">
            <div
              v-if="room.avatar"
              class="room-avatar"
              :style="{ 'background-image': `url('${room.avatar}')` }"
            ></div>
            <div>
              <div class="room-name">{{ room.roomName }}</div>
              <div v-if="typingUsers" class="room-info">
                {{ typingUsers }} {{ textMessages.IS_TYPING }}
              </div>
              <div v-else class="room-info">
                {{ userStatus }}
              </div>
            </div>
          </slot>
        </div>
        <div
          class="svg-button room-options p-3"
          v-if="menuActions.length"
          @click="menuOpened = !menuOpened"
        >
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="26.402" height="6.601" viewBox="0 0 26.402 6.601">
            <defs>
              <linearGradient id="linear-gradient" x1="3.109" y1="0.744" x2="-0.285" gradientUnits="objectBoundingBox">
                <stop offset="0" stop-color="#f17c08" stop-opacity="0.388" />
                <stop offset="1" stop-color="#c63e7c" />
              </linearGradient>
            </defs>
            <g id="more" transform="translate(0 -192)">
              <g id="Group_79" data-name="Group 79" transform="translate(0 192)">
                <g id="Group_78" data-name="Group 78">
                  <path
                    id="Path_154" data-name="Path 154" d="M3.3,192a3.3,3.3,0,1,0,3.3,3.3A3.3,3.3,0,0,0,3.3,192Zm0,5.5a2.2,2.2,0,1,1,2.2-2.2A2.2,2.2,0,0,1,3.3,197.5Z" transform="translate(0 -192)"
                    fill="url(#linear-gradient)"
                  />
                </g>
              </g>
              <g id="Group_81" data-name="Group 81" transform="translate(9.901 192)">
                <g id="Group_80" data-name="Group 80">
                  <path
                    id="Path_155" data-name="Path 155" d="M195.3,192a3.3,3.3,0,1,0,3.3,3.3A3.3,3.3,0,0,0,195.3,192Zm0,5.5a2.2,2.2,0,1,1,2.2-2.2A2.2,2.2,0,0,1,195.3,197.5Z"
                    transform="translate(-192 -192)" fill="url(#linear-gradient)"
                  />
                </g>
              </g>
              <g id="Group_83" data-name="Group 83" transform="translate(19.802 192)">
                <g id="Group_82" data-name="Group 82">
                  <path
                    id="Path_156" data-name="Path 156" d="M387.3,192a3.3,3.3,0,1,0,3.3,3.3A3.3,3.3,0,0,0,387.3,192Zm0,5.5a2.2,2.2,0,1,1,2.2-2.2A2.2,2.2,0,0,1,387.3,197.5Z"
                    transform="translate(-384 -192)" fill="url(#linear-gradient)"
                  />
                </g>
              </g>
            </g>
          </svg>
        </div>
        <transition name="slide-left" v-if="menuActions.length">
          <div
            v-if="menuOpened"
            v-click-outside="closeMenu"
            class="menu-options"
          >
            <div class="menu-list">
              <div v-for="action in menuActions" :key="action.name">
                <div class="menu-item" @click="menuActionHandler(action)">
                  {{ action.title }}
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <!--        <div v-if="messages.length === 0" style="height: 100%">-->
    <!--            <slot name="room-empty"></slot>-->
    <!--        </div>-->
    <div
      ref="scrollContainer"
      class="container-scroll"
      :class="{ 'scroll': messages.length > 0}"
      :style="scrollContainerStyles"
    >
      <loader :show="loadingMessages"></loader>
      <div class="messages-container" v-if="messages.length > 0">
        <div :class="{ 'messages-hidden': loadingMessages }">
          <transition name="fade-message">
            <div class="text-started" v-if="showNoMessages">
              {{ textMessages.MESSAGES_EMPTY }}
            </div>
            <div class="text-started" v-if="showMessagesStarted">
              {{ textMessages.CONVERSATION_STARTED }} {{ messages[0].date }}
            </div>
          </transition>
          <transition name="fade-message">
            <infinite-loading
              v-if="messages.length"
              spinner="spiral"
              direction="top"
              @infinite="loadMoreMessages"
            >
              <div slot="spinner">
                <loader :show="true" :infinite="true"></loader>
              </div>
              <div slot="no-results"></div>
              <div slot="no-more"></div>
            </infinite-loading>
          </transition>
          <transition-group name="fade-message">
            <div v-for="(message, i) in messages" :key="'message_'+i">

              <div v-if="i === 0 || (messages[i-1] && i > 0 && messages[i-1].user_id !== message.user_id)">
                <slot name="profile" v-bind="{ user_id: message.user_id }"></slot>
              </div>

              <message
                :currentUserId="currentUserId"
                :message="message"
                :index="i"
                :messages="messages"
                :editedMessage="editedMessage"
                :messageActions="messageActions"
                :roomUsers="room.users"
                :textMessages="textMessages"
                :roomFooterRef="$refs.roomFooter"
                :newMessages="newMessages"
                :showReactionEmojis="showReactionEmojis"
                :textFormatting="textFormatting"
                :emojisList="emojisList"
                :hideOptions="hideOptions"
                :showDatesBelowMessages="showDatesBelowMessages"
                @messageActionHandler="messageActionHandler"
                @openFile="openFile"
                @addNewMessage="addNewMessage"
                @sendMessageReaction="sendMessageReaction"
                @hideOptions="hideOptions = $event"
              >
                <template v-slot:image="slotProps">
                  <slot name="image" v-bind="slotProps"></slot>
                </template>
                <template v-slot:message-bottom="slotProps">
                  <slot name="message-bottom" v-bind="slotProps"></slot>
                </template>
              </message>

              <!--                            <MessageDiviner :message="message" :nextMessage="messages[i+1]"></MessageDiviner>-->
            </div>
          </transition-group>
        </div>
      </div>
      <div v-else-if="!loadingMessages" style="height: 100%">
        <slot name="room-empty"></slot>
      </div>
    </div>
    <div v-if="!loadingMessages">
      <transition name="bounce">
        <div class="icon-scroll" v-if="scrollIcon" @click="scrollToBottom">
          <svg-icon name="dropdown" param="scroll" />
        </div>
      </transition>
    </div>
    <div ref="roomFooter" class="room-footer" v-if="Object.keys(room).length">
      <transition name="slide-up">
        <div v-if="messageReply" class="reply-container">
          <div class="reply-box">
            <img
              v-if="isImageCheck(messageReply.file)"
              :src="messageReply.file.url"
              class="image-reply"
            />
            <div class="reply-info">
              <div class="reply-username">{{ messageReply.username }}</div>
              <div class="reply-content">{{ messageReply.content }}</div>
            </div>
          </div>

          <div class="icon-reply">
            <div class="svg-button" @click="resetMessage">
              <svg-icon name="close-outline" />
            </div>
          </div>
        </div>
      </transition>

      <div class="box-footer-row">
        <slot name="room-box-footer">
          <div class="image-container" v-if="imageFile">
            <div class="svg-button icon-image" @click="resetImageFile">
              <svg-icon name="close" param="image" />
            </div>
            <div class="image-file">
              <img ref="imageFile" :src="imageFile" />
            </div>
          </div>

          <div
            v-else-if="file"
            class="file-container"
            :class="{ 'file-container-edit': editedMessage._id }"
          >
            <div class="icon-file">
              <svg-icon name="file" />
            </div>
            <div class="file-message">{{ message }}</div>
            <div class="svg-button icon-remove" @click="resetMessage(null, true)">
              <svg-icon name="close" />
            </div>
          </div>
          <slot name="room-textarea">
            <div class="textmessage-area">
              <textarea
                v-show="!file || imageFile"
                ref="roomTextarea"
                :placeholder="textMessages.TYPE_MESSAGE"
                :class="{'textarea-outline': editedMessage._id}"
                :style="{'min-height': `${imageDimensions ? imageDimensions.height : 20}px`,'padding-left': `${imageDimensions ? imageDimensions.width - 10 : 12}px`}"
                v-model="message"
                @input="onChangeInput"
                @keydown.esc="resetMessage"
                @keydown.enter.exact.prevent=""

              ></textarea>
              <div
                @click="sendMessage"
                class="text-button"
                :class="{ 'send-disabled': inputDisabled }"
              >
                <slot name="room-send">
                  <svg-icon name="send" :param="inputDisabled ? 'disabled' : ''" />
                </slot>
              </div>
            </div>
          </slot>
          <div class="icon-textarea">
            <div
              class="svg-button"
              v-if="editedMessage._id"
              @click="resetMessage"
            >
              <svg-icon name="close-outline" />
            </div>

            <emoji-picker
              v-if="showEmojis && (!file || imageFile)"
              :emojiOpened="emojiOpened"
              :positionTop="true"
              @addEmoji="addEmoji"
              @openEmoji="emojiOpened = $event"
            ></emoji-picker>

            <slot name="room-buttons"></slot>
            <div v-if="showFiles" class="svg-button" @click="launchFilePicker">
              <svg id="surface1" xmlns="http://www.w3.org/2000/svg" width="25.623" height="25.624" viewBox="0 0 25.623 25.624">
                <path
                  id="Path_141" data-name="Path 141"
                  d="M24.342,4.271H19.805A3.1,3.1,0,0,0,19.221.816,3.1,3.1,0,0,0,17.052,0h0a4.807,4.807,0,0,0-3.261,1.4,5,5,0,0,0-.976,1.29A4.983,4.983,0,0,0,11.837,1.4,4.806,4.806,0,0,0,8.574,0h0A3.1,3.1,0,0,0,6.4.816a3.1,3.1,0,0,0-.584,3.456H1.281A1.281,1.281,0,0,0,0,5.553v5.979a1.281,1.281,0,0,0,1.281,1.281h.427V24.343a1.281,1.281,0,0,0,1.281,1.281H23.061a.854.854,0,0,0,.854-.854V12.813h.854a.854.854,0,0,0,.854-.854V5.553A1.281,1.281,0,0,0,24.342,4.271ZM14.489,2A3.661,3.661,0,0,1,17.013.855a2.043,2.043,0,0,1,1.486.569,2.5,2.5,0,0,1,.246,2.847h-5.1l-.244-.3A3.872,3.872,0,0,1,14.489,2Zm.458,22.77H10.676V5.126h4.271ZM7.123,1.424A2.044,2.044,0,0,1,8.608.855,3.663,3.663,0,0,1,11.134,2a3.864,3.864,0,0,1,1.087,1.965l-.242.306h-5.1A2.506,2.506,0,0,1,7.123,1.424ZM.854,11.531V5.553a.427.427,0,0,1,.427-.427H9.822v6.833H1.281A.427.427,0,0,1,.854,11.531ZM2.989,24.77a.427.427,0,0,1-.427-.427V12.813h7.26V24.77Zm20.072-.427a.427.427,0,0,1-.427.427H15.8V12.813h7.26Zm1.708-12.812a.427.427,0,0,1-.427.427H15.8V5.126h8.541a.427.427,0,0,1,.427.427Zm0,0"
                  transform="translate(0 0)" fill="#adacac"
                />
              </svg>
            </div>

            <input
              v-if="showFiles"
              type="file"
              ref="file"
              @change="onFileChange($event.target.files)"
              style="display:none"
            />
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading';
import vClickOutside from 'v-click-outside';
import emojis from 'vue-emoji-picker/src/emojis';
import { mapGetters } from 'vuex';

import Loader from './Loader';
import Message from './Message';
import SvgIcon from './SvgIcon';
import EmojiPicker from './EmojiPicker';

const { messagesValid } = require('../utils/roomValidation');
const { detectMobile } = require('../utils/mobileDetection');

export default {
  name: 'room',
  components: {
    InfiniteLoading,
    Loader,
    Message,
    SvgIcon,
    EmojiPicker,
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    activeRoom: { type: Object, default: null },
    currentUserId: { type: [String, Number], required: true },
    textMessages: { type: Object, required: true },
    singleRoom: { type: Boolean, required: true },
    showRoomsList: { type: Boolean, required: true },
    isMobile: { type: Boolean, required: true },
    // rooms: {
    //   type: Object, default: () => ({
    //     messages: [],
    //     matches: [],
    //     length: 0
    //   }), required: true
    // },
    roomId: { type: [String, Number], required: true },
    messages: { type: Array, required: true },
    roomMessage: { type: String },
    messagesLoaded: { type: Boolean, required: true },
    menuActions: { type: Array, required: true },
    messageActions: { type: Array, required: true },
    showFiles: { type: Boolean, required: true },
    showEmojis: { type: Boolean, required: true },
    showReactionEmojis: { type: Boolean, required: true },
    textFormatting: { type: Boolean, required: true },
    loadingRooms: { type: Boolean, required: true },
    roomInfo: { type: Function },
    showDatesBelowMessages: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      message: '',
      editedMessage: {},
      messageReply: null,
      infiniteState: null,
      loadingMessages: false,
      loadingMoreMessages: false,
      file: null,
      imageFile: null,
      imageDimensions: null,
      menuOpened: false,
      emojiOpened: false,
      emojisList: {},
      hideOptions: true,
      scrollIcon: false,
      newMessages: []
    };
  },
  mounted() {
    this.newMessages = [];

    window.addEventListener('keyup', e => {
      if (e.keyCode === 13 && !e.shiftKey) {
        if (detectMobile()) {
          this.message = this.message + '\n';
          setTimeout(() => this.onChangeInput(), 0);
        } else {
          this.sendMessage();
        }
      }
    });

    this.$refs.scrollContainer.addEventListener('scroll', e => {
      this.hideOptions = true;
      setTimeout(() => {
        if (!e.target) return;
        this.scrollIcon =
          e.target.scrollHeight > 500 &&
          e.target.scrollHeight - e.target.scrollTop > 1000;
      }, 200);
    });

    const emojisTable = Object.keys(emojis).map(key => emojis[key]);
    this.emojisList = Object.assign({}, ...emojisTable);
  },
  watch: {
    loadingMessages(val) {
      if (val) this.infiniteState = null;
      else this.focusTextarea(true);
    },
    room(newVal, oldVal) {
      if (newVal.roomId && newVal.roomId !== oldVal.roomId) {
        this.loadingMessages = true;
        this.scrollIcon = false;
        this.resetMessage(true);
        if (this.roomMessage) {
          this.message = this.roomMessage;
          setTimeout(() => this.onChangeInput(), 0);
        }
      }
    },
    messagesLength(newVal, oldVal) {
      const element = this.$refs.scrollContainer;
      const options = { top: element.scrollHeight };

      if (oldVal === newVal - 1) {
        return setTimeout(() => {
          options.behavior = 'smooth';
          element.scrollTo(options);
        }, 50);
      }
    },
    messages(newVal, oldVal) {
      newVal.forEach(message => {
        if (!messagesValid(message)) {
          throw 'Messages object is not valid! Must contain _id[String, Number], content[String, Number] and sender_id[String, Number]';
        }
      });

      const element = this.$refs.scrollContainer;
      if (!element) return;

      const options = { top: element.scrollHeight };

      if (this.infiniteState) {
        this.infiniteState.loaded();
        setTimeout(() => (this.loadingMoreMessages = false), 0);
      } else if (newVal.length) {
        setTimeout(() => {
          element.scrollTo(options);
          this.loadingMessages = false;
        }, 0);
      }
    },
    messagesLoaded(val) {
      if (val) this.loadingMessages = false;
      if (this.infiniteState) this.infiniteState.complete();
    },
    imageFile() {
      setTimeout(() => {
        if (!this.$refs.imageFile) {
          this.imageDimensions = null;
          setTimeout(() => this.resizeTextarea(), 0);
        } else {
          let height = this.$refs.imageFile.height;
          if (height < 30) height = 30;

          this.imageDimensions = {
            height: this.$refs.imageFile.height - 10,
            width: this.$refs.imageFile.width + 26
          };
        }
      }, 20);
    }
  },
  computed: {
    ...mapGetters('chat', {
      inputFocused: 'getMessageInputFocused',
    }),

    scrollContainerStyles() {
      if (this.inputFocused && this.messages.length && this.messages.length <= 5 && this.isMobile) {
        return {
          // maxHeight: '35vh',
          paddingTop: (this.messages.length <= 3) ? '36vh' : '30vh'
        };
      } else {
        return {};
      }
    },
    room() {
      return this.activeRoom ?? {};
    },
    showNoMessages() {
      return (
        this.room.roomId &&
        !this.messages.length &&
        !this.loadingMessages &&
        !this.loadingRooms
      );
    },
    showMessagesStarted() {
      return this.messages.length && this.messagesLoaded;
    },
    inputDisabled() {
      return this.isMessageEmpty();
    },
    typingUsers() {
      if (!this.room.typingUsers || !this.room.typingUsers.length) return;

      const typingUsers = this.room.users.filter(user => {
        if (user._id === this.currentUserId) return;
        if (this.room.typingUsers.indexOf(user._id) === -1) return;
        if (user.status && user.status.state === 'offline') return;
        return true;
      });

      return typingUsers.map(user => user.username).join(', ');
    },
    userStatus() {
      if (!this.room.users || this.room.users.length !== 2) return;

      const user = this.room.users.find(u => u._id !== this.currentUserId);

      if (!user.status) return;

      let text = '';

      if (user.status.state === 'online') {
        text = this.textMessages.IS_ONLINE;
      } else if (user.status.last_changed) {
        text = this.textMessages.LAST_SEEN + user.status.last_changed;
      }

      return text;
    },
    messagesLength() {
      return this.messages.length;
    },
  },
  methods: {
    addNewMessage(message) {
      this.newMessages.push(message);
    },
    resetMessage(disableMobileFocus = null, editFile = null) {
      this.$emit('typingMessage', null);

      if (editFile) {
        this.file = null;
        this.message = '';
        return;
      }

      this.resetTextareaSize();
      this.message = '';
      this.editedMessage = {};
      this.messageReply = null;
      this.file = null;
      this.imageFile = null;
      this.emojiOpened = false;
      setTimeout(() => this.focusTextarea(disableMobileFocus), 0);
    },
    resetImageFile() {
      this.imageFile = null;
      this.editedMessage.file = null;
      this.file = null;
      this.focusTextarea();
    },
    resetTextareaSize() {
      // if (!this.$refs['roomTextarea']) return
      // this.$refs['roomTextarea'].style.height = '20px'
    },
    focusTextarea(disableMobileFocus) {
      // if (detectMobile() && disableMobileFocus) return
      // this.$refs['roomTextarea'].focus()
    },
    isMessageEmpty() {
      return !this.file && !this.message.trim();
    },
    sendMessage() {
      if (!this.file && !this.message.trim()) return;

      if (this.editedMessage._id) {
        if (this.editedMessage.content !== this.message || this.file) {
          this.$emit('editMessage', {
            messageId: this.editedMessage._id,
            newContent: this.message.trim(),
            file: this.file,
            replyMessage: this.messageReply
          });
        }
      } else {
        this.$emit('sendMessage', {
          content: this.message.trim(),
          file: this.file,
          replyMessage: this.messageReply
        });
      }

      this.resetMessage(true);
    },
    loadMoreMessages(infiniteState) {
      if (this.messagesLoaded || !this.room.roomId) {
        return infiniteState.complete();
      }
      this.infiniteState = infiniteState;
      this.$emit('fetchMessages');
      this.loadingMoreMessages = true;
    },
    messageActionHandler({ action, message }) {
      switch (action.name) {
        case 'replyMessage':
          return this.replyMessage(message);
        case 'editMessage':
          return this.editMessage(message);
        case 'deleteMessage':
          return this.$emit('deleteMessage', message._id);
        default:
          return this.$emit('messageActionHandler', { action, message });
      }
    },
    sendMessageReaction(messageReaction) {
      this.$emit('sendMessageReaction', messageReaction);
    },
    replyMessage(message) {
      this.resetMessage();
      this.messageReply = message;
    },
    editMessage(message) {
      this.resetMessage();
      this.editedMessage = { ...message };
      this.file = message.file;
      if (this.isImageCheck(this.file)) this.imageFile = message.file.url;
      this.message = message.content;

      setTimeout(() => this.resizeTextarea(), 0);
    },
    scrollToBottom() {
      const element = this.$refs.scrollContainer;
      element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
    },
    onChangeInput() {
      this.resizeTextarea();
      this.$emit('typingMessage', this.message);
    },
    resizeTextarea() {
      // const el = this.$refs['roomTextarea']
      //
      // if (!el) return
      //
      // const padding = window
      //     .getComputedStyle(el, null)
      //     .getPropertyValue('padding-top')
      //     .replace('px', '')
      //
      // el.style.height = 0
      // el.style.height = el.scrollHeight - padding * 2 + 'px'
    },
    addEmoji(emoji) {
      this.message += emoji.icon;
      this.focusTextarea(true);
    },
    launchFilePicker() {
      this.$refs.file.value = '';
      this.$refs.file.click();
    },
    async onFileChange(files) {
      this.resetImageFile();
      const file = files[0];
      const fileURL = URL.createObjectURL(file);
      const blobFile = await fetch(fileURL).then(res => res.blob());

      this.file = {
        blob: blobFile,
        name: file.name.split('.')[0],
        size: file.size,
        type: file.name.split('.')[1] || file.type,
        localUrl: fileURL
      };
      if (this.isImageCheck(this.file)) this.imageFile = fileURL;
      else this.message = file.name;
    },
    isImageCheck(file) {
      if (!file) return;
      const imageTypes = ['png', 'jpg', 'jpeg', 'svg'];
      const { type } = file;
      return imageTypes.some(t => type.includes(t));
    },
    openFile(message) {
      this.$emit('openFile', message);
    },
    menuActionHandler(action) {
      this.closeMenu();
      this.$emit('menuActionHandler', action);
    },
    closeMenu() {
      this.menuOpened = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.col-messages {
  position: relative;
  height: 100%;
  flex: 1;
  // overflow: hidden;
  display: flex;
  flex-flow: column;
}

.room-header {
  position: absolute;
  display: flex;
  align-items: center;
  height: 64px;
  width: 100%;
  z-index: 10;
  margin-right: 1px;
  background: var(--chat-header-bg-color);
  border-top-right-radius: var(--chat-container-border-radius);
}

.room-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 0 16px;
}

.info-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.toggle-button {
  margin-right: 15px;

  svg {
    height: 26px;
    width: 26px;
  }
}

.rotate-icon {
  transform: rotate(180deg) !important;
}

.room-name {
  font-size: 17px;
  font-weight: 500;
  line-height: 22px;
  color: var(--chat-header-color-name);
}

.room-info {
  font-size: 13px;
  line-height: 18px;
  color: var(--chat-header-color-info);
}

.room-options {
  margin-left: auto;
}

.container-scroll {
  background: var(--chat-content-bg-color);
  flex: 1;

  margin-right: 1px;
  margin-top: 60px;
  -webkit-overflow-scrolling: touch;

  &.scroll {
    overflow-y: scroll;
  }
}

.messages-container {
  padding: 0 5px 5px;
}

.text-started {
  font-size: 14px;
  color: var(--chat-message-color-started);
  font-style: italic;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
}

.icon-scroll {
  position: absolute;
  bottom: 80px;
  right: 20px;
  padding: 8px;
  background: var(--chat-bg-scroll-icon);
  border-radius: 50%;
  box-shadow: 0 1px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
  0 1px 2px 0 rgba(0, 0, 0, 0.12);
  display: flex;
  cursor: pointer;
  z-index: 10;

  svg {
    height: 25px;
    width: 25px;
  }
}

.room-footer {
  width: calc(100% - 1px);
  border-bottom-right-radius: 4px;
  z-index: 10;
}

.box-footer {
  display: flex;
  position: relative;
  background: var(--chat-footer-bg-color);
  padding: 10px 8px 10px;
}

.reply-container {
  display: flex;
  padding: 10px 10px 0 10px;
  background: var(--chat-content-bg-color);
  align-items: center;
  max-width: 100%;

  .reply-box {
    width: 100%;
    overflow: hidden;
    background: var(--chat-footer-bg-color-reply);
    border-radius: 4px;
    padding: 8px 10px;
    display: flex;
  }

  .reply-info {
    overflow: hidden;
  }

  .reply-username {
    color: var(--chat-message-color-reply-username);
    font-size: 12px;
    line-height: 15px;
    margin-bottom: 2px;
  }

  .reply-content {
    font-size: 12px;
    color: var(--chat-message-color-reply-content);
  }

  .icon-reply {
    margin-left: 10px;

    svg {
      height: 20px;
      width: 20px;
    }
  }

  .image-reply {
    max-height: 100px;
    margin-right: 10px;
  }
}

textarea {
  height: 20px;
  width: 100%;
  line-height: 20px;
  overflow: hidden;
  outline: 0;
  resize: none;
  border-radius: 20px;
  padding: 12px 16px;
  box-sizing: content-box;
  font-size: 16px;
  background: var(--chat-bg-color-input);
  color: var(--chat-color);
  caret-color: var(--chat-color-caret);
  border: var(--chat-border-style-input);

  &::placeholder {
    color: var(--chat-color-placeholder);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.textarea-outline {
  border: 1px solid var(--chat-border-color-input-selected);
  box-shadow: inset 0px 0px 0px 1px var(--chat-border-color-input-selected);
}

.icon-textarea {
  display: flex;
  margin: 12px 0 0 5px;

  svg,
  .wrapper {
    margin: 0 7px;
  }
}

.image-container {
  position: absolute;
  max-width: 25%;
  left: 16px;
  top: 18px;
}

.image-file {
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-height: 30px;

  img {
    border-radius: 15px;
    width: 100%;
    max-width: 150px;
    max-height: 100%;
  }
}

.icon-image {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 10;

  svg {
    height: 20px;
    width: 20px;
    border-radius: 50%;
  }

  &:before {
    content: ' ';
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    z-index: -1;
  }
}

.file-container {
  display: flex;
  align-items: center;
  width: calc(100% - 75px);
  height: 20px;
  padding: 12px 0;
  box-sizing: content-box;
  background: var(--chat-bg-color-input);
  border: var(--chat-border-style-input);
  border-radius: 20px;
}

.file-container-edit {
  width: calc(100% - 109px);
}

.file-message {
  max-width: calc(100% - 75px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.icon-file {
  display: flex;
  margin: 0 8px 0 15px;
}

.icon-remove {
  margin-left: 8px;

  svg {
    height: 18px;
    width: 18px;
  }
}

.send-disabled,
.send-disabled svg {
  cursor: none !important;
  pointer-events: none !important;
  transform: none !important;
}

.messages-hidden {
  opacity: 0;
}

@media only screen and (max-width: 768px) {
  .room-header {
    height: 50px;

    .room-wrapper {
      padding: 0 10px;
    }

    .room-name {
      font-size: 16px;
      line-height: 22px;
    }

    .room-info {
      font-size: 12px;
      line-height: 16px;
    }

    .room-avatar {
      height: 37px;
      width: 37px;
    }
  }

  .container-scroll {
    margin-top: 50px;
    transition: padding-top 0.3s ease-in-out;
  }

  .box-footer {
    border-top: var(--chat-border-style-input);
    padding: 7px 2px 7px 7px;
  }

  .text-started {
    margin-top: 20px;
  }

  textarea {
    padding: 7px;
    line-height: 18px;

    &::placeholder {
      color: transparent;
    }
  }

  .icon-textarea {
    margin: 6px 0 0 5px;

    svg,
    .wrapper {
      margin: 0 5px;
    }
  }

  .image-container {
    top: 10px;
    left: 10px;
  }

  .image-file img {
    transform: scale(0.97);
  }

  .room-footer {
    width: 100%;
  }

  .file-container {
    padding: 7px 0;

    .icon-file {
      margin-left: 10px;
    }
  }

  .reply-container {
    padding: 5px 8px;
  }

  .icon-scroll {
    bottom: 70px;
  }
}
</style>
